export default "__VITE_ASSET__Dcz7DWml__"